import axiosInstance from './axiosCreator';

export type ReferralHomeResponse = {
  enabled: boolean;
  referralCode?: string;
  referralLink?: string;
  summary?: {
    pendingCount: number;
    awaitingPaymentCount?: number;
    earnedCount?: number;
    completedCount: number;
    expiredCount: number;
    totalCount: number;
  };
  earnedCreditSummary?: {
    totalEarnedCents: number;
    totalAppliedCents: number;
    totalReversedCents: number;
    availableCreditCents: number;
  };
  reward?: {
    refereeDiscountCents: number;
    referrerCreditCents: number;
    currency: 'usd';
  };
  referrerRewardEligible?: boolean;
};

export type AttachReferralResponse = {
  enabled: boolean;
  outcome:
    | 'attached'
    | 'ineligible'
    | 'blocked'
    | 'ignored_already_attributed'
    | 'invalid_code';
  reasonCode?: string;
  attributionId?: string;
  attachedAt?: string;
  expiresAt?: string;
};

export type ReferralInviteResponse = {
  enabled: boolean;
  sent: boolean;
  referralLink?: string;
  reasonCode?: string;
};

export const getReferralHome = async (): Promise<ReferralHomeResponse> => {
  const response = await axiosInstance.get('/api/v5/referrals/me');
  return response.data;
};

const attachReferral = async (
  referralCode: string
): Promise<AttachReferralResponse> => {
  const response = await axiosInstance.post('/api/v5/referrals/attach', {
    referralCode,
  });

  return response.data;
};

export const sendReferralInvite = async (
  email: string
): Promise<ReferralInviteResponse> => {
  const response = await axiosInstance.post('/api/v5/referrals/me/invite', {
    email,
  });

  return response.data;
};

const REFERRAL_STORAGE_KEY = 'ora-refId';

const getStoredReferralCode = (): string | null => {
  return sessionStorage.getItem(REFERRAL_STORAGE_KEY);
};

const clearStoredReferralCode = (): void => {
  sessionStorage.removeItem(REFERRAL_STORAGE_KEY);
};

export const attachStoredReferralCodeIfPresent =
  async (): Promise<AttachReferralResponse | null> => {
    const referralCode = getStoredReferralCode();
    if (!referralCode) return null;

    try {
      const result = await attachReferral(referralCode);

      if (
        result.outcome === 'attached' ||
        result.outcome === 'ignored_already_attributed' ||
        result.outcome === 'blocked' ||
        result.outcome === 'ineligible'
      ) {
        clearStoredReferralCode();
      }

      return result;
    } catch (error) {
      console.error('Failed to attach stored referral code:', error);
      return null;
    }
  };
